import dynamic from 'next/dynamic';

export { ScommesseFiltersListSecondary } from './ScommesseFiltersListSecondary';
export type { ScommesseFiltersListSecondaryProps as ScommesseFiltersListSecondaryType } from './ScommesseFiltersListSecondary';

export const ScommesseFiltersListSecondaryDynamic = dynamic(
  () =>
    import('components/scommesseFiltersListSecondary/ScommesseFiltersListSecondary').then(
      (mod) => mod.ScommesseFiltersListSecondary
    ),
  { ssr: false }
);
